import {
  TELEGRAM_REACTIONS,
  DEFAULT_QUICK_REACTIONS,
} from 'dashboard/helper/telegramReactions';

// The reactions an operator uses most, for the quick row in the message
// menu. Kept in this browser only: a convenience, not something to sync.
const QUICK_COUNT = 6;

const storageKey = userId => `chatwoot:frequent-reactions:${userId}`;

const readCounts = userId => {
  try {
    return JSON.parse(localStorage.getItem(storageKey(userId))) || {};
  } catch (error) {
    return {};
  }
};

// The ones this operator has used, most used first. allowed: what Telegram
// lets the account set now; counts may hold earlier, refused picks.
export const usedReactions = (userId, allowed = TELEGRAM_REACTIONS) => {
  const counts = readCounts(userId);
  return Object.keys(counts)
    .filter(emoji => allowed.includes(emoji))
    .sort((a, b) => counts[b] - counts[a]);
};

// The quick row: the most used ones, then the defaults this messenger
// accepts, then the start of its own list (MAX has no 👌, for one).
export const frequentReactions = (userId, allowed = TELEGRAM_REACTIONS) => {
  const bare = emoji => emoji.replace(/\uFE0F/g, '');
  const defaults = DEFAULT_QUICK_REACTIONS.map(emoji =>
    allowed.find(option => bare(option) === emoji)
  ).filter(Boolean);
  const row = [...usedReactions(userId, allowed), ...defaults, ...allowed];
  return [...new Set(row)].slice(0, QUICK_COUNT);
};

export const rememberReaction = (userId, emoji) => {
  const counts = readCounts(userId);
  counts[emoji] = (counts[emoji] || 0) + 1;
  try {
    localStorage.setItem(storageKey(userId), JSON.stringify(counts));
  } catch (error) {
    // Private window or blocked storage: the defaults stay.
  }
};
